<template>
  <div class="loading-wrapper">
    Loading...
  </div>
</template>

<script>
export default {
  name: 'loading',
  data () {
    return {
      ready: false
    }
  },
  watch: {
    ready: function (newVal) {
      if (newVal) {
        if (window.localStorage.getItem('token') || this.$common.getCookie('token')) {
          this.initMyData().then(() => {
            this.$router.replace('/dashboard')
          }).catch(() => {
            this.$router.replace('/welcome')
          })
        } else {
          this.$router.replace('/welcome')
        }
      }
    }
  },
  mounted () {
    console.log(window.localStorage.getItem('token'), this.$common.getCookie('token'))
    let localStorageSysConfigs = JSON.parse(window.localStorage.getItem('site-configs'))
    if (localStorageSysConfigs && localStorageSysConfigs.data && localStorageSysConfigs.data.TITLE) {
      if (!localStorageSysConfigs.lastUpdateAt || this.$moment().diff(this.$moment(localStorageSysConfigs.lastUpdateAt), 'hours') >= 1) {
        // 过期
        this.getConfigs().then(() => {
          this.ready = true
        })
      } else {
        this.ready = true
      }
    } else {
      this.getConfigs().then(() => {
        this.ready = true
      })
    }
  },
  methods: {
    getConfigs () {
      return new Promise((resolve, reject) => {
        this.$Api.KVS.getKVS('SITE_CONFIGS').then((res) => {
          console.log(res, JSON.parse(res))
          let configsStr = res
          let configs = JSON.parse(configsStr)
          if (configs) {
            this.$store.dispatch('setConfigs', configs)
            document.title = configs.TITLE
            window.localStorage.setItem('current_theme', configs.THEME)
            if (configs.MAINTAINING === true) {
              if (window.location.href.indexOf('maintaining.html') < 0) {
                window.location.href = '/maintaining.html'
              }
            }
            resolve(configs)
          }
        }).catch(err => {
          this.$Message.error('初始化失败!' + err.message)
          reject(err)
        })
      })
    },
    initMyData () {
      return new Promise((resolve, reject) => {
        this.$Api.Auth(this).getMyDetail().then((data) => {
          this.$store.dispatch('setUserInfo', data)
          window.localStorage.setItem('userInfo', JSON.stringify(data))
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
      
    }
  }
}
</script>